export const SUCCESS_LOGIN = 'SUCCESS_LOGIN' 
export const LOG_OUT = 'LOG_OUT' 
export const SAVE_CATEGORIES = 'SAVE_CATEGORIES' 